export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

// Zimobi-owned message subtypes, carried in `zimobi_message_type` rather than in the upstream
// `message_type` / `content_type` enums, so new Chatwoot values can never collide with ours.
// Every one of them is an ordinary ACTIVITY message; the payload lives in content_attributes.
export const ZIMOBI_MESSAGE_TYPE = {
  CARD: 'card',
};

export const CONVERSATION_STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
};

export const CONVERSATION_PRIORITY = {
  URGENT: 'urgent',
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium',
};

export const CONVERSATION_PRIORITY_ORDER = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};

export const ALLOWED_FILE_TYPES =
  'image/*,' +
  'audio/*,' +
  'video/*,' +
  '.3gpp,' +
  'text/csv, text/plain, application/json, application/pdf, text/rtf,' +
  'application/xml, text/xml,' +
  'application/zip, application/x-7z-compressed application/vnd.rar application/x-tar,' +
  'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';

export const CSAT_RATINGS = [
  {
    key: 'disappointed',
    translationKey: 'CSAT.RATINGS.POOR',
    emoji: '😞',
    value: 1,
    color: '#FDAD2A',
  },
  {
    key: 'expressionless',
    translationKey: 'CSAT.RATINGS.FAIR',
    emoji: '😑',
    value: 2,
    color: '#FFC532',
  },
  {
    key: 'neutral',
    translationKey: 'CSAT.RATINGS.AVERAGE',
    emoji: '😐',
    value: 3,
    color: '#FCEC56',
  },
  {
    key: 'grinning',
    translationKey: 'CSAT.RATINGS.GOOD',
    emoji: '😀',
    value: 4,
    color: '#6FD86F',
  },
  {
    key: 'smiling',
    emoji: '😍',
    translationKey: 'CSAT.RATINGS.EXCELLENT',
    value: 5,
    color: '#44CE4B',
  },
];

export const CSAT_DISPLAY_TYPES = {
  EMOJI: 'emoji',
  STAR: 'star',
};

export const AUDIO_FORMATS = {
  WEBM: 'audio/webm',
  OGG: 'audio/ogg',
  MP3: 'audio/mp3',
  WAV: 'audio/wav',
};

// Zimobi: labels are shown to agents in the {{ variable picker and are kept in Portuguese here,
// since this list is not routed through i18n.
export const MESSAGE_VARIABLES = [
  {
    label: 'ID da conversa',
    key: 'conversation.id',
  },
  {
    label: 'ID do contato',
    key: 'contact.id',
  },
  {
    label: 'Nome do contato',
    key: 'contact.name',
  },
  {
    label: 'Primeiro nome do contato',
    key: 'contact.first_name',
  },
  {
    label: 'Sobrenome do contato',
    key: 'contact.last_name',
  },
  {
    label: 'E-mail do contato',
    key: 'contact.email',
  },
  {
    label: 'Telefone do contato',
    key: 'contact.phone_number',
  },
  {
    label: 'Últimos quatro dígitos do telefone do contato',
    key: 'contact.phone_last_four',
  },
  {
    label: 'Nome do agente',
    key: 'agent.name',
  },
  {
    label: 'Primeiro nome do agente',
    key: 'agent.first_name',
  },
  {
    label: 'Sobrenome do agente',
    key: 'agent.last_name',
  },
  {
    label: 'E-mail do agente',
    key: 'agent.email',
  },
  {
    key: 'inbox.name',
    label: 'Nome da caixa de entrada',
  },
  {
    label: 'ID da caixa de entrada',
    key: 'inbox.id',
  },
];

export const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
};

export const TWILIO_CONTENT_TEMPLATE_TYPES = {
  TEXT: 'text',
  MEDIA: 'media',
  QUICK_REPLY: 'quick_reply',
  CALL_TO_ACTION: 'call_to_action',
};
